import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import getBaseQueryWithReauth from '../../../utils/api/query-auth';
import {
  CompaniesFilters,
  handleItemList,
} from '../../slices/backoffice/backofficeCompaniesSlice';
import getAuth from '../../../utils/api/getToken';

const baseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_API_BASE_URL}/Company`,
  prepareHeaders: (headers) => {
    const token = getAuth();
    if (token) {
      headers.set('authorization', `Bearer ${token.auth}`);
    }
    return headers;
  },
});

export const backofficeApi: any = createApi({
  reducerPath: 'backoffice',
  baseQuery: getBaseQueryWithReauth(baseQuery),
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getCompaniesFiltered: builder.query({
      query: (filters: CompaniesFilters) => {
        const { companyId, orderByColumn, ascending, currentPage, pageSize } =
          filters;

        return {
          url: '/getCompaniesFiltered',
          params: {
            ascending,
            companyId,
            currentPage,
            pageSize,
            orderByColumn,
          },
        };
      },
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(
            handleItemList({
              itemList: data?.itemList,
            }),
          );
        } catch (err: any) {
          console.error(
            'backofficeApi.ts | backofficeApi ===> Error in getting PageDetails data',
          );
          console.error('backofficeApi.ts | backofficeApi ===> ' + err.message);
        }
      },
    }),
    getExportCompanies: builder.query({
      query: () => `/exportCompanies`, // it will change to export Companies
    }),
    putCompaniesDisabled: builder.mutation({
      query: (body) => ({
        url: `/disableCompanies`,
        method: 'PUT',
        body,
      }),
    }),
    getAllCompaniesFilter: builder.query({
      query: () => ({
        url: '/getAllCompaniesFilter',
        method: 'GET',
      }),
    }),
    getCompanyAccess: builder.query({
      query: (companyDatabaseId: number) => ({
        url: '/getCompanyAccess',
        method: 'GET',
        params: { companyDatabaseId },
      }),
    }),
    putUpdateCompanyAccess: builder.mutation({
      query: (body) => ({
        url: '/updateCompanyAccess',
        method: 'PUT',
        body,
      }),
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useGetCompaniesFilteredQuery,
  useGetExportCompaniesQuery,
  useLazyGetExportCompaniesQuery,
  usePutCompaniesDisabledMutation,
  useGetAllCompaniesFilterQuery,
  useGetCompanyAccessQuery,
  usePutUpdateCompanyAccessMutation,
} = backofficeApi;
